// extracted by css-extract-rspack-plugin
export default {"container":"_ae22a27b"};